<template>
<div class="headcon">
    <topban></topban>
    <div class="container">
        <headerbar></headerbar>
    </div>

</div>
</template>

<script>
import topban from "./topban.vue"
import headerbar from "./headerbar.vue"
export default {
    data() {
        return {}
    },
    components: {
        topban,
        headerbar
    }
}
</script>

<style lang="scss" scoped>
.headcon {
    position: fixed;
    background: #fff;
    box-shadow: rgba(167, 167, 168, .5) 0px 0px 4px 2px;
    overflow: hidden;
    width: 100%;
    z-index: 1;

    .container {
        width: 1120px;
        margin: 0 auto;
    }
}
</style>
